/* tslint:disable */

/**
 */
export class ViewSelect {
    selected?: number;
    value?: number;
    label?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-select.ts